import { track } from "../track";

export const trackContentDownload = (params: { content_id: string }) =>
  track({ event: "content_download", ...params });
